import { z } from "zod";
// I numeri di telefono nella forma che il server e i fornitori della telefonia si scambiano (piano M4): E.164. Qui una
// copia sola della regola, per la telefonia di ogni azienda (numeri ammessi, cellulare dell'ufficio da verificare).
/** Un numero in forma E.164: `+`, il prefisso del paese e al massimo 15 cifre in tutto (`+393331234567`). */
export const E164_PATTERN = /^\+[1-9]\d{6,14}$/;
export const e164Schema = z.string().regex(E164_PATTERN);
//# sourceMappingURL=phone.js.map